import i18next from 'i18next';
import { CardType } from '../components/TimetableVersion/graphql/types';

export function getConflictingCardLabel(
  placedUuids: string[],
  getCardByUuid: (uuid: string) => CardType | null | undefined,
): string {
  const cards = placedUuids
    .map((uuid) => {
      const card = getCardByUuid(uuid);
      if (!card) return null;
      const subject = card.subject?.name ?? '';
      const classes = card.classes.map((c) => c.name).join(', ');
      const groups = card.groups
        .map((g) => g.name)
        .filter(Boolean)
        .join('/');
      const classOrGroup = groups || classes;
      return [subject, classOrGroup].filter(Boolean).join(' ');
    })
    .filter(Boolean)
    .join(', ');

  if (!cards) return '';
  return `${i18next.t('pinboard.reason.conflictWith')} ${cards}`;
}
